
import { useTheme } from "next-themes"
import { Toaster as Sonner } from "sonner"

// Create a silent toast version that maintains API compatibility
const toast = {
  success: (message: string, options?: any) => {
    console.debug("[Silent Toast] Success:", message, options)
  },
  error: (message: string, options?: any) => {
    console.debug("[Silent Toast] Error:", message, options)
  },
  info: (message: string, options?: any) => {
    console.debug("[Silent Toast] Info:", message, options)
  },
  warning: (message: string, options?: any) => {
    console.debug("[Silent Toast] Warning:", message, options)
  },
  loading: (message: string, options?: any) => {
    console.debug("[Silent Toast] Loading:", message, options)
    return () => {}
  },
  promise: <T,>(promise: Promise<T>, options?: any) => {
    console.debug("[Silent Toast] Promise:", options)
    return promise
  },
  dismiss: (toastId?: string) => {
    console.debug("[Silent Toast] Dismiss:", toastId)
  },
  custom: (component: any, options?: any) => {
    console.debug("[Silent Toast] Custom:", options)
  },
  // Maintain compatibility with any other methods
  message: (message: string, options?: any) => {
    console.debug("[Silent Toast] Message:", message, options)
  }
}

type ToasterProps = React.ComponentProps<typeof Sonner>

// Maintain the Toaster component for compatibility, but don't show anything
const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  // Return empty div instead of the actual toaster
  return <div data-silent-toaster style={{ display: 'none' }} />
}

// Export both the silent toaster and the original components for compatibility
export { Toaster, toast, Sonner }
